export default __webpack_public_path__ + "media/images/landlords_page/benefits_1-16e4016bfbb924da807ef118fa948474.png";